import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const CloudUploadIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon {...props}>
    <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dii_882_7911)">
        <rect x="2" y="1.5" width="40" height="40" rx="8" fill="white" />
        <rect x="2.5" y="2" width="39" height="39" rx="7.5" stroke="#D5D7DA" />
        <path
          d="M18.667 24.8333L22.0003 21.5M22.0003 21.5L25.3337 24.8333M22.0003 21.5V29M28.667 25.4524C29.6849 24.6117 30.3337 23.3399 30.3337 21.9167C30.3337 19.3854 28.2816 17.3333 25.7503 17.3333C25.5682 17.3333 25.3979 17.2383 25.3054 17.0814C24.2187 15.2374 22.2124 14 19.917 14C16.4652 14 13.667 16.7982 13.667 20.25C13.667 21.9718 14.3632 23.5309 15.4894 24.6613"
          stroke="#535862"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_dii_882_7911"
          x="0"
          y="0.5"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0392157 0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_882_7911" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_882_7911" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_882_7911" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect3_innerShadow_882_7911" />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.18 0" />
          <feBlend mode="normal" in2="effect2_innerShadow_882_7911" result="effect3_innerShadow_882_7911" />
        </filter>
      </defs>
    </svg>
  </SvgIcon>
);
